import { ProductUid } from '../../domain/models/related-products.models';
import { RelatedProductsCarousel } from '../../infrastructure/state/related-products.state';

import { findProductUidOnProductArrayUseCase } from './find-product-uid-on-product-array.use-case';

import { ProductPublicModels } from '@features/products/product';

// #region PRIVATE
const filterExcluded = (
    products: ProductUid[],
    excludedProducts: ProductPublicModels.PublicProduct[]
): ProductUid[] => {
    // PRE: products -> este array debe de haber pasado antes ya por la funcion _generateProductUidArray
    if (!products) {
        return [];
    }

    if (!excludedProducts) {
        return products;
    }
    return products.filter((product: ProductUid) => {
        return !findProductUidOnProductArrayUseCase(excludedProducts, product);
    });
};

const filterRepeatedProductUids = (array: ProductUid[]): ProductUid[] => {
    const filteredArray: ProductUid[] = array.reduce((acc, curr) => {
        const isRepeated = acc.find((p) =>
            !!curr.mocaId && p.mocaId === curr.mocaId
            || !!curr.uid && !!curr.colorId && p.uid === curr.uid && p.colorId === curr.colorId
            || !!curr.product_id && p.product_id === curr.product_id) !== undefined;
        if (!isRepeated) {
            acc.push(curr);
        }
        return acc;
    }, []);

    return filteredArray;
};
// #endregion PRIVATE

// #region PUBLIC
export const mergeCarouselsFromPlaceWithProductsIdsUseCase = (
    relatedPlace: Record<string, Partial<RelatedProductsCarousel>>,
    productsIds: ProductUid[][],
    excludedProducts: ProductPublicModels.PublicProduct[]
): Record<string, Partial<RelatedProductsCarousel>> => {
    return Object.values(relatedPlace)
        .reduce((acc, carousel, index) => {
            const filteredExcluded = filterExcluded(
                productsIds[index],
                excludedProducts
            );
            const filteredRepeated = filterRepeatedProductUids(filteredExcluded);
            acc[carousel.id] = {
                ...carousel,
                currentPage: 0,
                filteredItemsIds: filteredRepeated,
                itemsIds: filteredRepeated,
                productsLoaded: {},
                productsViewed: 0,
            } as Partial<RelatedProductsCarousel>;
            return acc;
        }, {}) as Record<string, Partial<RelatedProductsCarousel>>;
};
// #endregion PUBLIC

// #region __TESTS__
export const __tests__ = {
    filterExcluded,
    filterRepeatedProductUids,
};
// #endregion __TESTS__
